import {
  SERVICE_PLAN_PHOTO,
  SERVICE_PLAN_FREE,
  SERVICE_PLAN_STANDARD,
  SERVICE_PLAN_NOTOPEN,
  SERVICE_PLAN_SUSPENDED,
  SERVICE_PLAN_ARCHIVED,
} from '@/constant/codmonPricing';

interface PlanNameStrategy {
  getPlanName(): string;
}

interface planNames {
  [key: number]: string;
}

export class Before202305Strategy implements PlanNameStrategy {
  constructor(private planId: number) {}

  getPlanName(): string {
    const planNameBefore202305: planNames = {
      [SERVICE_PLAN_PHOTO]: 'フリープラン',
      [SERVICE_PLAN_FREE]: 'デモプラン',
      [SERVICE_PLAN_STANDARD]: 'スタンダードプラン',
      [SERVICE_PLAN_NOTOPEN]: '未オープンプラン',
      [SERVICE_PLAN_SUSPENDED]: '休会中',
      [SERVICE_PLAN_ARCHIVED]: 'データ保存プラン',
    };
    return planNameBefore202305[this.planId];
  }
}

export class After202305Strategy implements PlanNameStrategy {
  constructor(private planId: number, private isMainFacility: boolean, private usePackplan: boolean) {}

  getPlanName(): string {
    const planNameAfter202305: planNames = {
      [SERVICE_PLAN_PHOTO]: '無料施設会員',
      [SERVICE_PLAN_FREE]: this.isMainFacility ? '本部アカウント（無料）' : 'コドモン無料期間',
      [SERVICE_PLAN_STANDARD]: this.usePackplan ? 'コドモンパックプラン' : 'コドモンベーシック',
      [SERVICE_PLAN_SUSPENDED]: '休会中',
      [SERVICE_PLAN_ARCHIVED]: 'データ保存プラン',
    };
    return planNameAfter202305[this.planId] ? planNameAfter202305[this.planId] : '-';
  }
}

export class PlanNameContext {
  constructor(private strategy: PlanNameStrategy) {}

  getPlanName(): string {
    return this.strategy.getPlanName();
  }
}
